var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 159,
    viewBox: "0 0 127 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0699 75.1312L16.0405 81.3037C16.0171 86.2005 16.7132 91.0742 18.1065 95.7686L19.9253 101.897",
    stroke: "#FABE53",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74283 82.1469L9.73948 82.8497C9.71612 87.7465 10.4122 92.6201 11.8055 97.3146L12.0427 98.1138",
    stroke: "#FABE53",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.031 89.5918L100.129 95.464C98.62 100.123 96.4349 104.534 93.6436 108.558L90 113.81",
    stroke: "#FABE53",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.847 98.2341L105.631 98.9027C104.122 103.561 101.937 107.973 99.1454 111.996L98.6701 112.681",
    stroke: "#FABE53",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5268 80.6131C49.0355 83.3791 60.6821 92.4043 55.198 106.377M42.5268 80.6131L48.937 35.64C48.938 35.6335 48.9395 35.627 48.9416 35.6207V35.6207C50.8715 29.7297 59.5605 30.6472 59.9894 36.8314V36.8314C59.9899 36.8388 59.9896 36.8462 59.9887 36.8536L56.1637 66.7363C56.0965 67.2614 56.8388 67.4434 57.0221 66.9467L68.4973 35.8527C68.4997 35.8459 68.5029 35.8394 68.5066 35.8333L68.7601 35.4129C72.0033 30.0341 80.2845 33.2382 79.0629 39.3991V39.3991L68.3888 72.1846C68.2232 72.6934 68.9317 73.0076 69.1976 72.5433L85.2788 44.4641C85.2854 44.4525 85.2939 44.4421 85.3039 44.4334V44.4334C89.7142 40.5709 96.4814 44.6537 95.1209 50.3562L95.0041 50.8459C95.0014 50.857 94.9972 50.8678 94.9916 50.8777L80.0902 77.4172C79.8384 77.8655 80.4218 78.3124 80.7892 77.9526L96.0515 63.002V63.002C99.6756 59.3317 105.764 63.1063 104.089 67.9847L103.893 68.5561C103.889 68.567 103.883 68.5771 103.876 68.5861L89.58 86.4412C87.1829 89.4351 85.7971 93.0947 84.615 96.7433C81.4606 106.479 73.6928 118.247 69.545 123.717L57.9901 150.501L21.2298 136.661L32.8619 110.315L23.3254 56.2308C23.18 55.4062 23.7753 54.6354 24.6098 54.5676V54.5676C31.8329 53.9808 38.3405 58.9232 39.7138 66.0388L42.5268 80.6131Z",
    stroke: "#FABE53",
    strokeWidth: 2.66832
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8618 110.315L69.6993 124.592",
    stroke: "#FABE53",
    strokeWidth: 2.66832
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.4058caa6fe1b23bffa62dc8ea290b0b0.svg";
export { ForwardRef as ReactComponent };